import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        // background: "#FFFFFF",
        background: "#f5ca6dff",
        primary: "#fdbc2c", // Gold from logo,
        // background: colors.blue.lighten5
        
      },
      options: {
        customProperties: true,
      },
    },
  },
});
